import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=0461d2de&scoped=true&"
import script from "./PasswordResetView.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetView.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=0461d2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461d2de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSpacer,VTextField})
